import React, { useState } from 'react';
import { CircularProgress } from '@mui/material';
import Select from '../../../../components/Select';
import Input from '../../../../components/Input';
import Button from '../../../../components/Button';
import { useAppDispatch, useAppSelector, useFetchCountries } from '../../../../hooks/redux';
import css from './AddIntegration.module.scss';
import { TState } from '../../types';
import { getBanks } from '../../../../store/reducers/countriesSlice';
import { parseBanksArrayToOptions, parseStringArrayToOptions } from '../../../../utils/parser';
import { addIntegration } from '../../../../store/reducers/integrationSlice';
import ModalMark from '../ModalMark';
import Modal from '../../../../components/Modal';

type TAddIntegration = {
  setState: React.Dispatch<React.SetStateAction<TState>>;
};

export const AddIntegration = ({ setState }: TAddIntegration) => {
  const dispatch = useAppDispatch();
  const { countries, banks, loading } = useAppSelector((state) => state.countriesReducer);
  const emptyState = {
    country: '',
    BankId: '',
    UserName: '',
    Password: '',
    ClientSecret: '',
    ExtClientId: '',
  };
  const [isOpen, setOpen] = useState<boolean>(false);
  const [fields, setFields] = useState<{
    country: string;
    BankId: string;
    UserName: string;
    Password: string;
    ClientSecret: string;
    ExtClientId: string;
  }>(emptyState);

  useFetchCountries();

  if (loading) {
    return <CircularProgress />;
  }
  const useSaveIntegration = () => {
    const { country, ...restProps } = fields;

    dispatch(addIntegration(restProps)).then((response) => {
      // @ts-ignore
      if (response?.payload?.paramsId) {
        setOpen(true);
      }
    });
  };
  const onClose = () => {
    setOpen(false);
    setState(TState.INTEGRATIONS);
  };

  return (
    <section className={css.root}>
      <div className={css.buttons}>
        <Select
          value={fields.country}
          onChange={(e) => {
            setFields({ ...fields, country: e.target.value });
            dispatch(getBanks({ countryCode: e.target.value }));
          }}
          options={parseStringArrayToOptions(countries || [])}
          placeholder="Select Country"
          label="Country"
          width={130}
        />
        <Select
          disabled={!banks}
          value={fields.BankId}
          onChange={(e) => {
            setFields({ ...fields, BankId: e.target.value });
          }}
          options={parseBanksArrayToOptions(banks || [])}
          placeholder="Available Banks Connections"
          label="Bank"
          width={303}
        />
      </div>
      <div className={css.credentials}>
        <div className={css.title}>Connectivity Credentials</div>
        <Input
          label="Username"
          placeholder="Enter username"
          value={fields.UserName}
          onChange={(e) => setFields({ ...fields, UserName: e.target.value })}
        />
        <Input
          label="Password"
          placeholder="Enter password"
          type="password"
          value={fields.Password}
          onChange={(e) => setFields({ ...fields, Password: e.target.value })}
        />
        <Input
          label="Client ID"
          placeholder="Enter Client ID"
          value={fields.ExtClientId}
          width="343px"
          onChange={(e) => setFields({ ...fields, ExtClientId: e.target.value })}
        />
        <Input
          label="Client Secret"
          placeholder="Enter client secret"
          value={fields.ClientSecret}
          width="343px"
          multiline
          rows={4}
          onChange={(e) => setFields({ ...fields, ClientSecret: e.target.value })}
        />
      </div>
      <div className={css.buttons}>
        <Button onClick={useSaveIntegration}>Save</Button>
        <Button
          color="error"
          onClick={() => {
            setState(TState.INTEGRATIONS);
            setFields(emptyState);
          }}
        >
          Cancel
        </Button>
      </div>
      <Modal isOpen={isOpen} handleClose={onClose}>
        <ModalMark type='success' />
        <div className={css.modalTitle}>Connectivity successfully created!</div>
        <div className={css.button}>
          <Button
            width="99px"
            size="medium"
            onClick={onClose}
            color="success"
          >
            OK
          </Button>
        </div>
      </Modal>
    </section>
  );
};
